import { produce } from 'immer'
import type { State } from '../../typings'
import type { SetActivitySummaryTabAction } from './typings'

export const setActivitySummaryTabProducer = produce<
  State,
  [SetActivitySummaryTabAction['payload']]
>((draft, payload) => {
  draft.tableState.paginationState.page = 0
  draft.activeTab = payload
})
